import { useState } from 'react';
import InitFilters from './constants/InitFiltering';
import { getCredit } from './hooks/hook';

const useCustomHook = () => {
  const [loading, setLoading] = useState(false);
  const [, setFilterParams] = useState(null);
  const [size, setSize] = useState(10);
  const [page, setPage] = useState(0);
  const [filters, setFilters] = useState(InitFilters(getCredit));
  const [loadingBtn, setLoadingBtn] = useState(false);
  const [dialog, setDialog] = useState({});
  const [creditList, setCreditList] = useState(null);
  const [creditListResult, setCreditListResult] = useState(null);

  return {
    loading,
    setLoading,
    setFilterParams,
    size,
    setSize,
    filters,
    setFilters,
    loadingBtn,
    setLoadingBtn,
    dialog,
    setDialog,
    creditList, setCreditList,
    page, setPage,
    creditListResult, setCreditListResult
  };
};

export default useCustomHook;
